module.exports = __webpack_public_path__ + "static/media/date_range.640999d6.svg";